import React from 'react';
import { ChevronDown } from 'react-feather';
import { isLocale, LOCALES, LOCALE_LABELS } from './types';
import { useI18n } from './I18nProvider';

export function LanguageSelector() {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className="relative" data-component="LanguageSelector">
      <select
        aria-label={t('language.label')}
        data-testid="ui-language-selector"
        value={locale}
        onChange={(event) => {
          if (isLocale(event.target.value)) {
            setLocale(event.target.value);
          }
        }}
        className="appearance-none h-9 md:h-10 pl-3 pr-8 rounded-lg border-2 border-[#e2e8f0] bg-white text-[#2c3e50] text-sm md:text-base font-medium cursor-pointer focus:outline-none focus:border-[#356BAD] focus:ring-2 focus:ring-[#356BAD]/10 hover:border-[#356BAD]"
      >
        {LOCALES.map((code) => (
          <option key={code} value={code}>
            {LOCALE_LABELS[code]}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <ChevronDown className="h-4 w-4 text-[#6c757d]" />
      </div>
    </div>
  );
}
